import { createContext, useReducer } from "react";

export const LeaderContext = createContext();

export const leaderReducer = (state, action) => {
    switch (action.type) {
        case 'SET_LEADER':
            return {
                leader: action.payload
            }
        case 'CREATE_LEADER':
            return {
                leader: [action.payload, ...state.leader]
            }
        case 'DELETE_LEADER':
            return {
                leader: state.leader.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const LeaderContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(leaderReducer, {
        leader: null
    });

    return (
        <LeaderContext.Provider value={{ ...state, dispatch }}>
            {children}
        </LeaderContext.Provider>
    );
};